enum ActionTypes {
  GET_BALANCE_REPORT = '@BALANCE_REPORT/GET_BALANCE_REPORT',
}

export default ActionTypes
